module.exports = __webpack_public_path__ + "img/4.012ebeb4.png";